GP.GPMod('PicUpload',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            // detect the File API (necessary for progressbar on upload)
            data.can_show_progress = !!(window.File && window.FileList);

            // if we're in FF, make sure its FF4+
            if ('MozAppearance' in document.documentElement.style && data.can_show_progress) {
                data.can_show_progress = !!(window.FormData && window.URL);
            }

            // check if we want to set the uploaded pic as primary pic (i.e. post_registration modal, etc...)
            if (typeof _modal_vars != 'undefined') {
                if (_modal_vars.hasOwnProperty('set_pic_as_primary')) {
                    data.set_pic_as_primary = !!_modal_vars.set_pic_as_primary;
                } else {
                    data.set_pic_as_primary = false;
                }

                data.force_private = _modal_vars.hasOwnProperty('force_private');
            } else {
                data.set_pic_as_primary = false;
            }

            if (typeof self_profile_view != 'undefined') {
                if (self_profile_view) {
                    data.add_pic_to_profile = true;
                }
            }
        },
        event_namespace:     'picupload',
        can_show_progress:   false,
        set_pic_as_primary:  false,
        force_private:       false,
        add_pic_to_profile:  false,
        media_type:         'image',
        selected_media_item: null,
        secondary_color_rgb: 'rgb(189, 16, 11)', // default fling color
        filenames: [],
        upload_urls: {
            image: '/members/user/upload_pic/',
            video: '/members/content/upload_video/'
        },
        premium_upload_urls: {
            image: '/members/premium/upload_photo/',
            video: '/members/premium/upload_video/'
        },
    };


    var apis = {
        records_form_submit: function(form) {
            var url = $(form).attr('action');

            self.api.json(url, {
                data:    $(form).serialize(),
                error:   function() {},
                success: function(json) {
                    if (self.app.Util.check_obj(json.html)) {
                        $("#records").html(json.html);
                    }
                }
            });
        },
        delete_content: function($clicked) {
            var $add_media_item = $clicked.closest('.add-media-item');
            var content_type = $add_media_item.data('content_type');

            var api_url = '',
                input   = {};

            if (content_type == 'image') {
                api_url = _util.clean_url('members/content/del_content');
                input = {
                    content_id: $add_media_item.data('content_id')
                };
            } else if (content_type == 'video') {
                api_url = _util.clean_url('members/content/del_upload_queue');
                input = {
                    queue_id: $add_media_item.data('queue_id')
                };
            }

            self.api.json(api_url, {
                type: 'POST',
                data: input
            }).done(function(json) {
                if (content_type == 'image') {
                    $clicked
                        .addClass('hide')
                        .siblings('.img-preview')
                        .css('background-image', 'none')
                        .siblings('.btn-media-add')
                        .removeClass('hide');
                } else if (content_type == 'video') {
                    $clicked
                        .addClass('hide')
                        .siblings('.video-preview')
                        .css('src', '')
                        .siblings('.btn-media-add')
                        .removeClass('hide');
                }
                $add_media_item.find('.btn-media-add').removeClass('hide');
                $add_media_item.removeClass('has-media video-processing');

            }).fail(function() {
                // error msg?
            });

        }
    };

    var events = {
        // media.add form submit stuff (from regular page load)
        gallery_add_forms: function() {
            // photo and video submit handlers
            $('form.media-upload').on('submit.media-add-regular-page', function() {
                // check filesize if the File API is supported
                var file_input   = $(this).find('input[type="file"]')[0];
                var max_filesize = $(this).find('input[name="max_file_size"]').val();
                if (file_input.files && file_input.files[0] && file_input.files[0].size > max_filesize) {
                    $('#successful_upload').html('<h3 style="text-align:center;">'+failure_message+'<span style="color:red;">'+max_filesize_error+'</span></h3>').show();
                    return false;
                } else {
                    $('#successful_upload').hide();
                    $('#currently_uploading').show();
                    return true;
                }
            });

            events.setup_records_form();
        },
        setup_records_form: function() {
            $("#records-submit-btn").on('click.'+data.event_namespace, function(e) {
                e.preventDefault();

                if (!$(this).hasClass('disabled')) {
                    $("#records-form").submit();
                }
            });

            $("#records-form").on('submit.'+data.event_namespace, function(e) {
                e.preventDefault();
                var form_submit_url = $(this).attr('action');

                if (form_submit_url.length > 0) {
                    $("#records-submit-btn").text('Saving...').toggleClass('disabled');

                    apis.records_form_submit(this);
                }
                return false;
            });
        },
        // guidlines for uploading pictures
        show_upload_guidlines: function() {
            var url = '/members/info/upload_guidelines&no_header=1';
            var new_window = window.open(url, 'name', 'height=750,width=470,scrollbars=1');
            if (window.focus && new_window) {
                new_window.focus();
            }
            return false;
        },
        // guidlines for usernames
        show_username_guidlines: function() {
            var url = '/members/info/username_guidelines&no_header=1';
            var new_window = window.open(url, 'name', 'height=750,width=470,scrollbars=1');
            if (window.focus && new_window) {
                new_window.focus();
            }
            return false;
        },
        setup_gallery_upload_modal: function() {
            data.init();
            events.setup_records_form();

            if (!data.can_show_progress) {
                $('#upload_progress_ie').css('display', 'block');
                $('#upload_progress').css('display', 'none');
                // FF < 4.0 does not allow click handler to trigger file input, so we show the ugly ass input
                $('#modal_file_input').addClass('show');
                $('#upload-button').css('display', 'none');
            }

            if (window.can_upload_file) {
                // file uploader (blueimp fileupload)
                $('#modal_file_input').fileupload({
                    url: '/members/media/add/',
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       true,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,
                    singleFileUploads: false,
                    limitMultiFileUploads: 20, // allow only 20 uploads at a time
                    add: function(e, data) {
                        // not sure if we can really check video type reliably via javascript.
                        // It's checked on the serverside
                        // TODO: either get rid of this, or check before uploading
                        if (true || handlers.validate_upload(data)) {
                           data.submit();
                        }
                    },
                    start: function(e) {
                        $('.error_container, .success_container').hide();
                        if (data.can_show_progress) {
                            $('#upload_progress .progress-bar').css('width', 0);
                        }
                        $('.notice_container').show();
                    },
                    progress: function(e, json) {
                        var progress = parseInt(json.loaded / json.total * 100, 10);

                        if (data.can_show_progress) {
                            // fix for firefox bug never reporting > 94% progress
                            if (progress > 94) {
                                progress = 100;
                            }
                            $('#upload_progress .progress-bar').css('width', progress + '%');
                        }
                    },
                    done: function(e, json) {
                        $('.notice_container').hide();

                        if (_util.check_obj(json.result)) {
                            var success = !!json.result.success;

                            if (json.result.hasOwnProperty('error')) {
                                // some other error coming back from image upload backend
                                $('.error_container p').remove();
                                $('.error_container').append('<p class="error">'+json.result.error[0]+'</p>').show();
                            } else if (success !== true) {
                                // xhr error
                                $('.error_container p').remove();
                                $('.error_container').append('<p class="error">'+_modal_vars.error_messages[100]+'</p>').show();
                            } else {
                                // success
                                $('.success_container').show();
                                setTimeout(function() {
                                    $('.success_container').hide();
                                }, 3500);

                                $('#media-modal-form').trigger('reset');
                                $('#upload-button').text('Upload Another...');
                            }
                        }
                    }
                });
            } else {
                $('#modal_file_input').click(function(e) {
                    e.preventDefault();
                    alert(js_lang.no_file_upload);
                });
            }


            // hooking up the upload button
            $('#upload-button, .file-drop-wrap').on('click.'+data.event_namespace, function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (data.can_show_progress) {
                    $('#upload_progress .progress-bar').css('width', 0);
                }

                $('#modal_file_input').trigger('click');
                return false;
            });

            // media-upload tab
            $('#media-upload-tab').on('click.'+data.event_namespace, function(e) {
                e.preventDefault();
                $(".fling-modal .guidelines-tab").hide();
                $(".fling-modal .upload-tab").show();

                $(this).addClass('active');
                $("#guidelines-tab").removeClass('active');
            });

            // guidelines tab
            $('#guidelines-tab').on('click.'+data.event_namespace, function(e) {
                e.preventDefault();
                $(".fling-modal .guidelines-tab").show();
                $(".fling-modal .upload-tab").hide();

                $(this).addClass('active');
                $("#media-upload-tab").removeClass('active');
            });
        },
        setup_profile_pic_upload_modal: function() {
            data.init();

            if (!data.can_show_progress) {
                $('#upload_progress_ie').css('display', 'block');
                $('#upload_progress').css('display', 'none');
                // FF < 4.0 does not allow click handler to trigger file input, so we show the ugly ass input
                $('#modal_file_input').css('position', 'relative').css('left', '0');
                $('#upload-button').css('display', 'none');

            } else {
                var multiple = true;

                if (window._is_mobile || window._is_tablet) {
                    // disable multiple file selection for ios mobile safari
                    if (_util.check_ios() && _util.check_safari()) {
                        multiple = false;
                    }
                }

                // only add multiple for non mobile safari browsers (causes ios safari to not be able to use the camera)
                if (multiple) {
                    $('#modal_file_input').attr('multiple', 'multiple');
                }
            }

            var $modal = self.app.Modal.get_modal();

            // force the private tab if clicked from the profile
            if ($modal.hasClass('js-force-private')) {
                $('#tab-private-upload').tab('show');
            }

            var primary_el = document.querySelector('.btn-primary');
            if (primary_el) {
                data.secondary_color_rgb = getComputedStyle(primary_el).getPropertyValue("background-color");
            }

            // word count check for caption
            $('#caption_pic').simplyCountable({
                container        : '.message-char-count',
                showNum          : 0,
                counter          : '.message-char-count .count',
                countType        : 'characters',
                maxCount         : _modal_vars.caption_max,
                strictMax        : true,
                countDirection   : 'up',
                thousandSeparator: ''
            });

            // add process hidden input to form (since the file upload isn't really ajax)
            $('<input/>').attr({
                type: 'hidden',
                name: 'process',
                value: 'true'
            }).prependTo(".modal-form");

            // add hidden form field to ensure upload is tagged as private if needed
            if (data.force_private) {
                $('<input/>').attr({
                    type: 'hidden',
                    name: 'force_private',
                    value: 'true'
                }).prependTo(".modal-form");

                $('.upload-private-check').prop({
                    disabled: true,
                    checked: true
                });
            }

            if (window.can_upload_file) {
                // file uploader (blueimp fileupload)
                $('#modal_file_input').fileupload({
                    url: '/members/user/upload_pic/',
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       true,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,
                    singleFileUploads: false,
                    limitMultiFileUploads: 20, // allow only 20 uploads at a time
                    drop: function (e, upload_data) {
                        // set dat.selected_media_item to the first .add-media-item without a pic/video preview
                        data.selected_media_item = $('.add-media-item:not(".has-media"):first');
                    },
                    add: function(e, upload_data) {
                        if (handlers.validate_upload(upload_data)) {
                            window._gp_pic_uploading = true;

                            // Change upload url for videos
                            if (data.media_type == 'video') {
                                upload_data.url = '/members/content/upload_video/';
                            }

                            if (data.selected_media_item) {
                                data.selected_media_item.addClass('active');
                            }

                            upload_data.submit();
                        }
                    },
                    start: function(e) {
                        $('.error_container, .success_container').hide();

                        if (data.can_show_progress) {
                            data.selected_media_item.find('.circle-progress-wrap').circleProgress({
                                value: 0,
                                size: 50,
                                fill: {
                                  color: data.secondary_color_rgb
                                }
                            });
                        }
                        // $('.notice_container').show();

                    },
                    progress: function(e, json) {
                        var progress = parseInt(json.loaded / json.total * 100, 10);

                        if (data.can_show_progress) {
                            // fix for firefox bug never reporting > 94% progress
                            if (progress > 94) {
                                progress = 100;
                            }
                            // $('#upload_progress .progress-bar').css('width', progress + '%');
                            var $_circle_loader = data.selected_media_item.find('.circle-progress-wrap');
                            $_circle_loader.circleProgress({
                                value: json.loaded / json.total,
                            });
                        }
                    },
                    done: function(e, json) {
                        // $('.notice_container').hide();
                        $('.error_container').hide();
                        if (!json || !json.hasOwnProperty('textStatus') || json.textStatus != 'success' || !json.result) {
                            // xhr error
                            data.selected_media_item.removeClass('active');
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+_modal_vars.error_messages[100]+'</p>').show();
                        } else if (json.result[0] && json.result[0].hasOwnProperty('error')) {
                            // some other error coming back from image upload backend
                            data.selected_media_item.removeClass('active');
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+json.result[0].error+'</p>').show();
                        } else if (json.result.error && json.result.hasOwnProperty('error')) {
                            // error coming back from upload_video module
                            data.selected_media_item.removeClass('active');
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+json.result.error[0]+'</p>').show();
                        } else {
                            // success
                            var $modal = self.app.Modal.get_modal();
                            var silver_modal = false;

                            $('.success_container').show();
                            setTimeout(function() {
                                $('.success_container').hide();
                                $('.pic-wrap').addClass('upload-complete');
                                _modal_vars.thumb_count++;
                            }, 3500);

                            if (!$modal.hasClass('keep-buttons')) {
                                $("#pic-button-wrap").hide();
                            }

                            $('.upload-done-button').removeClass('hide');

                            if (data.media_type == 'image') {
                                handlers.show_image_preview(json.result[0].url, json.result[0].content_id);

                                // hide pg nudge bar on homepage only if user uploaded a public pic
                                if (typeof json.result[0].tags == 'undefined') {
                                    $('.btn-pg-nudge-bar').hide();
                                }
                            }

                            if (data.media_type == 'video') {
                                if (json.result.queue_id) {
                                    handlers.show_video_preview(json.files[0], json.result.queue_id);
                                } else {
                                    // show error, like video was uploaded already?
                                }
                                return true; // skip the pic specific logic if we uploaded a video
                            }

                            // Hide Missing Photo Nag
                            $('#home-wrap > .alert-missing-photo:visible').fadeOut();

                            // pic-upload: change upload btn text, show "done" button
                            /*
                            if ($modal.hasClass('pic-upload') && !$modal.hasClass('post-reg')) {
                                $('#upload-button').text(_modal_vars.upload_more);
                                $('.pic_upload_count').text(_modal_vars.add_photos);
                                // reset the caption count
                                $('.message-char-count .count').text('0');
                                // remove caption and anonymous toggle so they can upload anew
                                $('#caption_pic').val('');
                                $('#anon_pic').attr('checked',false);
                                $("#upload-done-button").removeClass('hide').show();
                            }
                            */

                            $.each(json.result, function(index, obj) {
                                if (obj.hasOwnProperty('error')) {
                                    $('.error_container p').remove();
                                    $('.error_container').append('<p class="error">'+obj.error+'</p>').show();
                                } else {

                                    handlers.add_thumb_to_profile(obj);

                                    if ($modal.hasClass('js-silver-upgrade')) {
                                        handlers.add_thumb_to_silver_upgrade(obj);
                                    } else if ($modal.hasClass('hotornot')) {
                                        handlers.show_hotornot();
                                    }

                                    if (obj.membership_change) {
                                        GP.sdata.my_user.membership = obj.membership_change;
                                        vent.trigger('MessagePane:reset');
                                    }
                                }
                            });


                            // replace no pic with uploaded pic and change the css for the image after it loads
                            if (typeof document.querySelector !== 'undefined') {
                                $("#profile-pic").imagesLoaded( function() {
                                    $("#profile-pic").css('width', 'auto').show();
                                });
                                $("#profile-pic").hide().attr('src', _modal_vars.media_url + json.result[0].M);
                            } else {
                               $("#profile-pic").hide().attr('src', _modal_vars.media_url + json.result[0].M).css('width', 'auto').show();
                            }

                            // optionally set to primary
                            if (data.set_pic_as_primary) {
                                // don't set pic as primary for subsequent pic uploads
                                data.set_pic_as_primary = false;
                                vent.trigger('profile:set_primary_pic', json.result[0].content_id, json.result[0].file_md5, json.result[0].content_media_id);
                                GP.sdata.my_user.has_pic = true;
                            }

                            vent.trigger('hotpick:hide_upload_notice');
                        }
                        window._gp_pic_uploading = false;
                    }
                });
            } else {
                $('#modal_file_input').click(function(e) {
                    e.preventDefault();
                    alert(js_lang.no_file_upload);
                });
            }

            // guidlines for uploading pictures
            $('.fling-modal .upload-guidelines').on('click.'+data.event_namespace, events.show_upload_guidlines);
            // guidlines for usernames
            $('.fling-modal .username-guidelines').on('click.'+data.event_namespace, events.show_username_guidlines);


            $('.fling-modal .modal-footer img.thumb').on('click.'+data.event_namespace, function(e) {
                $("#file-container").show();
                // $("#webcam-container").hide();
                $("#video-intro-container").hide();
                $("#file-upload-tab").addClass('active');
                $("#webcam-upload-tab").removeClass('active');

                var thumb_url = $(this).attr('src');
                $("#profile-pic").css('width', 'auto').attr('src', thumb_url.replace('-S-', '-M-'));
            });

            // delete pic
            var confirm_str = js_lang.profile_text.confirm_del;
            $('.fling-modal .modal-footer').on('click.'+data.event_namespace, '.delete-ico', function() {
                // warn user about losing silver_promo/verified_profile on deletion of last pic
                if ($('.fling-modal .modal-footer .thumb-wrapper').length === 1) {
                    if (GP.sdata.my_user.membership == 'SILVER_PROMO' && GP.sdata.my_user.verified_pic == 'Y') {
                        confirm_str = js_lang.profile_text.confirm_del_silver_verified;
                    } else if (GP.sdata.my_user.membership == 'SILVER_PROMO') {
                        confirm_str = js_lang.profile_text.confirm_del_silver;
                    } else if (GP.sdata.my_user.verified_pic == 'Y') {
                        confirm_str = js_lang.profile_text.confirm_del_verified;
                    }
                }

                if (confirm(confirm_str)) {
                    var pic_num    = $(this).siblings('img.thumb').attr('id').split('_').pop();
                    var $thumb_div = $(this).siblings('img.thumb').parent();
                    $.post(_util.clean_url('members/user/manage_pics'), { action:'remove', picnum:pic_num }, function(post_data) {
                        $thumb_div.fadeOut(300, function() { $(this).remove(); });
                        if (post_data.membership_change) {
                            GP.sdata.my_user.membership = post_data.membership_change;
                            vent.trigger('MessagePane:reset');
                        }
                    });
                }
            });

            $('.add-media-item').on('click.'+data.event_namespace, function(e) {

                if ($(this).hasClass('has-media')) {
                    return;
                }

                $('#modal_file_input').trigger('click');
                $('.add-media-item').removeClass('active');
                data.selected_media_item = $(this);
            });

            $('.btn-media-del').on('click.'+data.event_namespace, function(e) {
                apis.delete_content($(this));
            });

            $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
                handlers.tab_actions(e);
            });

            // switch to the video intro tab if we clicked the link to upload a video intro
            if ($modal.original_input && $modal.original_input.videointro) {
                $('#tab-intro-upload').tab('show');
            }

            // refresh these pages if user uploads a face pic so they can see the new prompts to continue the verification process
            $('.upload-done-button').on('click', function() {
                if (_current_module_page == 'user:verify' || _current_module_page == 'user:verify_photobooth') {
                    window.location.reload(true);
                }
            });
        },
        chat_upload: function(jsonObj) {
            var post_url, room_id, chat_api_url;

            if (typeof jsonObj == 'undefined' || !jsonObj) {
                return;
            }

            upload_url   = jsonObj.url;
            room_id      = jsonObj.room_id;
            chat_api_url = jsonObj.api_url;

            if (!upload_url || !room_id) {
                return;
            }
            data.init();

            if (!data.can_show_progress) {
                $('#upload_progress_ie').css('display', 'block');
                $('#upload_progress').css('display', 'none');
                // FF < 4.0 does not allow click handler to trigger file input, so we show the ugly ass input
                $('#chat-file-input').css('position', 'relative').css('left', '0');
                // $('#upload-button').css('display', 'none');

            } else {
                var multiple = true;

                if (window._is_mobile || window._is_tablet) {
                    // disable multiple file selection for ios mobile safari
                    if (_util.check_ios() && _util.check_safari()) {
                        multiple = false;
                    }
                }

                // only add multiple for non mobile safari browsers (causes ios safari to not be able to use the camera)
                if (multiple) {
                    // $('#chat-file-input').attr('multiple', 'multiple');
                }
            }

            if (window.can_upload_file) {
                $('#chat-file-input').fileupload({
                    url: upload_url,
                    formData: {
                        process:      true,
                        room_id:      room_id,
                        api_url:      chat_api_url
                    },
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       true,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,
                    add: function(e, data) {
                        if (handlers.validate_upload(data)) {
                           vent.trigger('Modal:open:static', {
                                modal_div_id: '#chat-upload-info-modal',
                                hide: 'default'
                            });
                           data.submit();
                        }
                    },
                    start: function(e) {
                        $('.error_container, .success_container').hide();
                        if (data.can_show_progress) {
                            $('#upload_progress .progress-bar').css('width', 0);
                        }
                        $('.notice_container').show();
                    },
                    progress: function(e, json) {
                        var progress = parseInt(json.loaded / json.total * 100, 10);

                        if (data.can_show_progress) {
                            // fix for firefox bug never reporting > 94% progress
                            if (progress > 94) {
                                progress = 100;
                            }
                            $('#upload_progress .progress-bar').css('width', progress + '%');
                        }
                    },
                    done: function(e, json) {
                        $('.notice_container').hide();
                        if (!json || !json.hasOwnProperty('textStatus') || json.textStatus != 'success') {
                            // xhr error
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+_modal_vars.error_messages[100]+'</p>').show();
                        } else if (json.result[0].hasOwnProperty('error') && json.result[0].error !== 0) {
                            // some other error coming back from image upload backend
                            $('.error_container p').remove();
                            $('.error_container').append('<p class="error">'+json.result[0].error+'</p>').show();
                        } else {
                            // success
                            var $modal = self.app.Modal.get_modal();

                            $('.success_container').show();
                            setTimeout(function() {
                                $('.success_container').hide();
                                $('.pic-wrap').addClass('upload-complete');
                            }, 3500);

                            if (!$modal.hasClass('keep-buttons')) {
                                $("#pic-button-wrap").hide();
                            }

                            $.each(json.result, function(index, obj) {
                                if (obj.hasOwnProperty('error') && obj.error !== 0) {
                                    $('.error_container p').remove();
                                    $('.error_container').append('<p class="error">'+obj.error+'</p>').show();
                                } else {
                                    // add to chat area?
                                    // sending pic through cometd from php so all users
                                    // (including the sending user) will receive via subscription handler/cometd
                                    // GP.vent.trigger('Chat:add_pic_upload', obj.urls.L);
                                }
                            });

                            // close modal?
                            vent.trigger('Modal:close');
                        }
                    }
                });
            } else {
                // $('#chat-file-input').click(function(e) {
                //     e.preventDefault();
                //     alert(js_lang.no_file_upload);
                // });
                alert(js_lang.no_file_upload);
            }

            $('#chat-file-input').trigger('click');
        },
        setup_mobile_post_upload_modal: function() {
            data.init();

            if (!data.can_show_progress) {
                $('#upload_progress_ie').css('display', 'block');
                $('#upload_progress').css('display', 'none');
                // FF < 4.0 does not allow click handler to trigger file input, so we show the ugly ass input
                $('#modal_file_input').css('position', 'relative').css('left', '0');
                $('#upload-button').css('display', 'none');

            } else {
                var multiple = true;

                if (window._is_mobile || window._is_tablet) {
                    // disable multiple file selection for ios mobile safari
                    if (_util.check_ios() && _util.check_safari()) {
                        multiple = false;
                    }
                }

                // only add multiple for non mobile safari browsers (causes ios safari to not be able to use the camera)
                if (multiple) {
                    // $('#modal_file_input').attr('multiple', 'multiple');
                }
            }

            var primary_el = document.querySelector('.btn-primary');
            if (primary_el) {
                data.secondary_color_rgb = getComputedStyle(primary_el).getPropertyValue("background-color");
            }

            // word count check for caption
            $('#caption_pic').simplyCountable({
                container        : '.message-char-count',
                showNum          : 0,
                counter          : '.message-char-count .count',
                countType        : 'characters',
                maxCount         : _modal_vars.caption_max,
                strictMax        : true,
                countDirection   : 'up',
                thousandSeparator: ''
            });


            var $fileupload = null;

            if (window.can_upload_file) {
                // file uploader (blueimp fileupload)
                $fileupload = $('#modal_file_input').fileupload({
                    dataType:         'json',
                    type:             'POST',
                    autoUpload:       false,
                    progressInterval: 50, // default 100ms
                    bitrateInterval:  200,
                    replaceFileInput: false,
                    add: function(e, upload_data) {

                        if (handlers.validate_upload(upload_data)) {
                            window._gp_pic_uploading = true;

                            var $preview_wrap;

                            // Change upload url for videos
                            if (data.media_type == 'video') {
                                var video_src = URL.createObjectURL(upload_data.files[0]);
                                $preview_wrap = $('.mobile-post .video-preview');
                                $preview_wrap.find('video').attr('src', video_src);
                            } else {
                                var img_src = URL.createObjectURL(upload_data.files[0]);
                                $preview_wrap = $('.mobile-post .img-preview');
                                $preview_wrap.find('img').attr('src', img_src);
                            }

                            //show image preview
                            $preview_wrap.removeClass('hide');
                            events.show_post_details();

                            $("#upload-button").off('click').removeClass('disabled').on('click', function () {
                                // Premium uploads require a caption
                                if (events.is_upload_premium() && !events.validate_caption()) {
                                    return false;
                                }

                                upload_data.submit();
                            });

                            $('.btn-preview-del').one('click', function(e) {
                                e.preventDefault();
                                e.stopPropagation();

                                if (data.media_type == 'video') {
                                    $preview_wrap.find('video').attr('src', '');
                                } else {
                                    $preview_wrap.find('img').attr('src', '');
                                }

                                $preview_wrap.addClass('hide');
                                events.show_add_media();

                                upload_data.abort();
                                upload_data = null;
                                document.querySelector('#modal_file_input').value = null;
                                data.filenames = [];

                                // remove any event handlers/reset state since we will be setting them all up again
                                $('#upload_pic-modal-form').off('submit');
                                $('.add-file-wrap').off('click.'+data.event_namespace);
                                $("#upload-button").off('click');
       
                                $('.error_container').hide();

                                $fileupload.fileupload('destroy');
                                events.setup_mobile_post_upload_modal();
                            });
                        }
                    },
                    url: data.upload_urls.image, // Default URL, will be overridden in submit
                    submit: function(e, upload_data) {
                        // change url for premium uploads
                        if ($('#mobile-upload-type').val() == 'premium') {
                            if (data.media_type == 'video') {
                               upload_data.url  = data.premium_upload_urls.video;
                            } else {
                                upload_data.url = data.premium_upload_urls.image;
                            }
                        } else {
                            if (data.media_type == 'video') {
                                upload_data.url = data.upload_urls.video;
                            } else {
                                upload_data.url = data.upload_urls.image;
                            }
                        }
                    },
                    start: function(e) {
                        $('.error_container, .success_container, .notice-video-processing').hide();

                        if (data.can_show_progress) {
                            events.show_mobile_upload_progress();
                        }
                    },
                    progress: function(e, json) {
                        var progress = parseInt(json.loaded / json.total * 100, 10);

                        if (data.can_show_progress) {
                            // fix for firefox bug never reporting > 94% progress
                            if (progress > 94) {
                                progress = 100;
                            }
                            events.update_progress_circle(progress);
                        }
                    },
                    done: function(e, json) {
                        // reset Post/Posting/upload button
                        // $('#upload-button-posting, #upload-button').addClass('hide');
                        // $('.notice_container').hide();

                        var error = '';

                        if (!json || !json.hasOwnProperty('textStatus') || json.textStatus != 'success' || !json.result) {
                            // xhr error
                            error = _modal_vars.error_messages[100];
                        } else if (json.result[0] && json.result[0].hasOwnProperty('error')) {
                            // some other error coming back from image upload backend
                            error = json.result[0].error;
                        } else if (json.result.error && json.result.hasOwnProperty('error')) {
                            // error coming back from upload_video module
                            error = json.result.error[0];
                        } else if (json.result.files && json.result.files[0] && json.result.files[0].hasOwnProperty('error')) {
                            error = json.result.files[0].error;
                        }

                        if (error) {
                            events.show_mobile_post_error(error);
                            events.show_post_details();
                        } else {
                            // success
                            var $modal = self.app.Modal.get_modal();
                            var silver_modal = false;

                            events.show_mobile_upload_done();

                            // auto close modal/overlay
                            setTimeout(function() {
                                vent.trigger('Modal:close');
                            }, 3500);

                            // Hide Missing Photo Nag
                            // $('#home-wrap > .alert-missing-photo:visible').fadeOut();

                            $.each(json.result, function(index, obj) {
                                if (obj.hasOwnProperty('error')) {
                                    events.show_mobile_post_error(obj.error);
                                } else {

                                    if (data.media_type == 'image') {
                                        handlers.add_thumb_to_profile(obj);
                                    }

                                    if (obj.membership_change) {
                                        GP.sdata.my_user.membership = obj.membership_change;
                                        vent.trigger('MessagePane:reset');
                                    }
                                }
                            });
                        }

                        window._gp_pic_uploading = false;
                    }
                });
            } else {
                $('#modal_file_input').click(function(e) {
                    e.preventDefault();
                    alert(js_lang.no_file_upload);
                });
            }


            // setup initial state and event handlers below
            $("#upload-button").addClass('disabled');

            // ensure native form submit event is overridden since it will be handle by fileupload
            $('#upload_pic-modal-form').on('submit', function(e) {
                e.preventDefault();
                return false;
            });

            // trigger adding file to upload
            $('.add-file-wrap').on('click.'+data.event_namespace, function(e) {
                e.preventDefault();
                e.stopPropagation();

                if (data.can_show_progress) {
                    $('#upload_progress .progress-bar').css('width', 0);
                }

                if (e.target.className === 'btn-media-del') {
                    return false;
                }

                $('#modal_file_input').trigger('click');
                return false;
            });

            // setup tab content
            $('.details-tab-item').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                if ($(this).data('tab') === 'everyone') {
                    $('#upload-button-disabled').addClass('hidden');
                    $('#upload-button').removeClass('hidden');
                } else if ($(this).data('tab') === 'premium' && show_premium_reg) {
                    // show the disabled button if user hasn't registered for premium
                    $('#upload-button').addClass('hidden');
                    $('#upload-button-disabled').removeClass('hidden');
                }
            });
        },
        show_post_details: function() {
            $('#add-file-step').addClass('hide');
            $('.post-details-wrap').removeClass('hide');
            $('#upload-progress-wrap').addClass('hide');
        },
        show_add_media: function() {
            $('#add-file-step').removeClass('hide');
            $('.post-details-wrap').addClass('hide');
        },
        show_mobile_post_error: function(error) {
            $('.mobile-post .error_container p').remove();
            $('.mobile-post .error_container').append('<p class="ml-0">'+error+'</p>').show();
        },
        show_mobile_upload_progress: function() {
            $('#add-file-step, .post-details-wrap').addClass('hide');
            $('#upload-progress-wrap').removeClass('hide');
        },
        show_mobile_upload_done: function() {
            $('#success-badge-wrap').removeClass('hide');
            $('#upload-done-wrap').removeClass('hide');

            $('#post-badge-wrap').addClass('hide');
            $('#cancel-button-wrap').addClass('hide');
            $('#upload-progress-wrap').addClass('hide');

            if (data.media_type == 'video') {
                // $('.notice-video-processing').show();
            }
        },
        validate_caption: function() {
            var caption = $('#caption_pic').val();

            if (!caption || caption.length < 10) {
                events.show_mobile_post_error('A caption with at least 10 characters is required');
                return false;
            }
            return true;
        },
        update_progress_circle: function(progress) {
            // Get the SVG circle element
            const progressCircle = document.querySelector('#upload-progress-wrap circle:last-child');
            if (!progressCircle) {
                return;
            }

            // Calculate the circumference and offset
            const radius = 45;
            const circumference = 2 * Math.PI * radius;
            const offset = circumference - (circumference * progress / 100);

            // Update the stroke-dashoffset
            progressCircle.style.strokeDashoffset = offset;

            // Update the percentage text
            const percentText = document.querySelector('#upload-progress-wrap .text-gray-900');
            if (percentText) {
                percentText.textContent = Math.round(progress) + '%';
            }
        },
        is_upload_premium: function() {
            return ($('#mobile-upload-type').val() == 'premium');
        }
    };


    var handlers = {
        add_thumb_to_silver_upgrade: function(json) {
            if (typeof json.tags != 'undefined' && $.isArray(json.tags)) {
                if ($.inArray('PRIVATE', json.tags) >= 0) {
                    return false;
                }
            }
            // browser will sometimes cache pics when uploading & deleting & show the wrong pic, rand prevents that
            var rand = Math.floor((Math.random()*1000)+1);

            // get the first unused pic space, first selector is so we dont pick up the templates
            var $tmp_pic = $('<img/>')
                .attr('src', _modal_vars.media_url + json.S)
                .attr('id', 'user-pic-' + json.content_id)
                .addClass('pic');
            var $pic_wrap = $('<div/>').addClass('pic').html($tmp_pic);

            $('.user-pic-s .add-pic').parent('.user-pic-s').first().html($pic_wrap);
            $('#photo-check').attr('class', 'success');
        },
        show_hotornot: function() {
            $('#hotornot_img_box').show();
        },
        add_thumb_to_profile: function(json) {
            // only add pic to profile, if the user is viewing their own profile
            if (data.add_pic_to_profile) {
                // browser will sometimes cache pics when uploading & deleting & show the wrong pic, rand prevents that
                var rand = Math.floor((Math.random()*1000)+1);
                var href = "/members/user/profile/?type=profile&duid=" + user_duid + "&mid=" + json.pic_order;

                var $template = $('#clone-templates .profile-photo-wrap').clone();
                    $template.find('.profile-photo img').attr('src', _modal_vars.media_url + json.L);
                    $template.find('.profile-photo a').attr('href', href);
                    $template.find('.dropdown li a').data('picnum', json.pic_num);

                // Update profile content collection
                vent.trigger("Content:update_profile_feed", json);
            }
        },
        // add_thumb_to_modal: function(json, prefix) {
        //     var tmp_pic = $('#clone-templates .pic-thumb-template').get(0).innerHTML;
        //     var $imgDiv = $('<div/>').addClass('thumb-wrapper').html(tmp_pic);
        //     $imgDiv.find('img.thumb').attr({
        //         src: prefix      + json.S,
        //         id:  'user_pic_' + json.content_id
        //     });

        //     $('.fling-modal .modal-footer').append($imgDiv);
        // },
        init_webcam_pic_upload: function (onCompleteCallback) {
            if (webcam.api_url.length > 0) {
                // webcam.reset();
            } else {
                // jpegcam (photobooth) setup
                webcam.set_api_url('/members/user/upload_pic/?webcam=1&ajax_request=1&process=1');
                webcam.set_swf_url('/jpegcam/webcam.swf');
                webcam.set_quality(90);
                webcam.set_shutter_sound(true, '/jpegcam/shutter.mp3');
                $('#jpegcam').html(webcam.get_html(350,300));
                $('#jpegcam_controls .step2').hide();

                $('#jpegcam_shoot').click(function(e) {
                    e.preventDefault();
                    $(this).hide();
                    $('#jpegcam_controls .step2').show();
                    webcam.freeze();
                });

                $('#jpegcam_cancel').click(function(e) {
                    e.preventDefault();
                    webcam.reset();
                    $('#jpegcam_controls .step2').hide();
                    $('#jpegcam_controls .step1').show();
                });

                $('#jpegcam_upload').click(function(e) {
                    e.preventDefault();
                    webcam.upload();
                    $('#jpegcam_controls .step1, #jpegcam_controls .step2').hide();
                    $('#jpegcam_uploading').css('display', 'inline-block');
                });

                webcam.set_hook('onCameraMissingBusy', function() {
                    alert(_modal_vars.camera_missing_busy);
                });

                webcam.set_hook('onCameraReady', function() {
                    $('#jpegcam_controls').slideDown();
                });

                webcam.set_hook('onPermissionDeny', function() {
                    alert(_modal_vars.upload_allow);
                    $('#jpegcam_controls').slideUp();
                });

                webcam.set_hook('onComplete', onCompleteCallback);

                webcam.set_hook('onError',function(e) {
                    webcam.reset();
                    $('#jpegcam_controls .step2').hide();
                    $('#jpegcam_controls .step1').show();
                });
            }
        },
        // success callback for pic-upload modal
        webcam_oncomplete: function(msg) {
            $('#jpegcam_uploading').hide();
            $('#jpegcam_controls .step2').hide();
            $('#jpegcam_controls .step1').show();

            msg = $.parseJSON(msg);
            if (!msg[0].hasOwnProperty('error')) {
                // hide controls & show success container
                $('#jpegcam_controls').hide();
                $('#webcam-container .success_container').show();
                setTimeout(function() {
                    $('#webcam-container .success_container').hide();
                    $('#jpegcam_controls').show();
                }, 3500);

                handlers.add_thumb_to_profile(msg[0]);

                if (msg[0].membership_change) {
                    GP.sdata.my_user.membership = msg[0].membership_change;
                    vent.trigger('MessagePane:reset');
                }
            } else {
                $('.error_container p').remove();
                $('.error_container').append('<p class="error">'+msg[0].error+'</p>').show();
            }
            webcam.reset();
            $('#jpegcam_controls .step2').hide();
            $('#jpegcam_controls .step1').show();
        },
        // success callback for post registration modal, with pic upload
        webcam_oncomplete_post_reg: function(msg) {
            $('#jpegcam_uploading').hide();
            $('#jpegcam_controls .step2').hide();
            $('#jpegcam_controls .step1').show();

            msg = $.parseJSON(msg);
            if (!msg[0].error) {
                // hide controls & show success container
                $('#jpegcam_controls').hide();
                $('.success_container').show();
                setTimeout(function() {
                    $('.success_container').hide();
                    $('#jpegcam_controls').show();
                    $('.pic-wrap').addClass('upload-complete').removeClass('webcam');
                }, 3500);

                $("#file-container").show();
                $("#webcam-container").hide();

                if (!$(".fling-modal").hasClass('keep-buttons')) {
                    $("#pic-button-wrap").hide();
                }

                $("#profile-pic").css('width', 'auto').attr('src', _modal_vars.media_url + msg[0].M);

                // replace nav thumb with new pic
                $("#mem-photo-t, #mem-photo-s").attr('src', _modal_vars.media_url + msg[0].S);

                if (msg[0].membership_change) {
                    GP.sdata.my_user.membership = msg[0].membership_change;
                    vent.trigger('MessagePane:reset');
                }
            } else {
                //alert('upload error, dave');
            }
            webcam.reset();
            $('#jpegcam_controls .step2').hide();
            $('#jpegcam_controls .step1').show();
        },
        validate_upload: function(json) {
 
            var errors = '';
            if (!handlers.check_file_type(json)) {
                if (json.files.length && json.files[0]) {
                    // validate filetype
                    if (json.files.length && json.files[0].name) {
                        var extension = json.files[0].name.split('.').pop().toLowerCase();
                        match = false;
                        $.each(_modal_vars.allowed_filetypes, function(ext, mimetype) {
                            if (ext == extension) {
                                match = true;
                                return true; // break out of .each
                            }
                        });
                        if (!match) {
                            errors += '<p class="error">'+_modal_vars.error_messages[102]+'</p>';
                        }
                    }
                    // validate filesize
                    if (typeof json.files[0].size != 'undefined') {
                        if (json.files[0].size === 0) {
                            errors += '<p class="error">'+_modal_vars.error_messages[104]+'</p>';
                        } else if (json.files[0].size > _modal_vars.max_filesize) {
                            errors += '<p class="error">'+_modal_vars.error_messages[1]+'</p>';
                        }
                    }
                } else {
                    errors += '<p class="error">'+_modal_vars.error_messages[7]+'</p>';
                }
            }

            // check for duplicate filenames in upload modal
            if (json.files[0].name) {
                var _filename = json.files[0].name;
                if (data.filenames.length === 0) {
                    data.filenames.push(_filename);
                } else {
                    $.each(data.filenames, function(index, _fname) {
                        if (_filename === _fname) {
                            errors += '<p class="error">'+_modal_vars.error_messages[9]+'</p>';
                            return true;
                        }
                    });
                    data.filenames.push(_filename);
                }
            }


            // show/hide error container
            var error_container = $('.error_container');
            if (errors) {
                if (error_container.is(':hidden')) {
                    error_container.show();
                }
                error_container.find('p.error').remove();
                error_container.append(errors);
                return false;
            } else {
                error_container.find('p.error').remove();
                error_container.hide();
                return true;
            }
        },
        check_file_type: function(json) {
            // var file_input = $('#content-file-input')[0].files[0],
            var file_input = json.files[0],
                image_types = /^image\/(gif|jpe?g|png|bmp)$/i,

                // This is for IE<10 because file mimetypes isn't defined in the file data
                image_names = /\.(gif|jpe?g|png|bmp)$/i,
                video_types = /^video\/(mp4|m4v|wmv|avi|mov|asf|quicktime|divx|ddat|webm|3gpp|x-flv|ogg|mpeg|mpg|flv|h264|h265|VP8|VP9)$/i,
                video_names = /\.(mp4|m4v|wmv|avi|mov|asf|ddat|webm|flv|3gp|ogv|mpeg|mpg|mpeg4|mp4v|divx|h264|h265)$/i;

            if ((typeof(file_input.type) !== 'undefined' && image_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && image_names.test(file_input.name))) {
                data.media_type = 'image';
                return true;
            } else if ((typeof(file_input.type) !== 'undefined' && video_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && video_names.test(file_input.name))) {
                data.media_type = 'video';
                return true;
            } else {
                // events.show_post_error(js_lang.unacceptable_file_type);
            }

            return false;
        },
        show_video_preview: function(_file, _queue_id) {
            // data.selected_media_item.find('.video-preview').attr('src', URL.createObjectURL(_file));
            data.selected_media_item.removeClass('active')
            .attr('data-queue_id', _queue_id)
            .attr('data-content_type', 'video')
            .addClass('has-media video-processing');

            // hide add media button
            data.selected_media_item.find('.btn-media-add').addClass('hide');

            // show delete button
            data.selected_media_item.find('.btn-media-del').removeClass('hide');

            data.selected_media_item = null;

            // show video processing notice
            $('.notice-video').show().delay(8000).fadeOut();
        },
        show_image_preview: function(_url, _content_id) {
            data.selected_media_item.find('.img-preview').css('background-image', 'url(' + _url + ')');
            data.selected_media_item.removeClass('active')
            .attr('data-content_id', _content_id)
            .attr('data-content_type', 'image')
            .addClass('has-media');

            // hide add media button
            data.selected_media_item.find('.btn-media-add').addClass('hide');

            // show delete button
            data.selected_media_item.find('.btn-media-del').removeClass('hide');

            data.selected_media_item = null;
        },
        tab_actions: function(e) {
            var _tab_name = $(e.target).data('tab-name');

            if (_tab_name == 'PRIVATE') {
                // add hidden form field to ensure upload is tagged as private if needed
                $('<input/>').attr({
                    type: 'hidden',
                    name: 'force_private',
                    value: 'true'
                }).prependTo(".modal-form");

                $('.upload-private-check').prop({
                    disabled: true,
                    checked: true
                });
                $('#video-intro-flag').val(0);

                // Hide private option if user has no pics.
                if (GP.sdata.my_user.has_pic) {
                    $('#tab-private-media').removeClass('disabled');
                } else {
                    $('#tab-private-media').addClass('disabled');
                }

                $('.upload-title').addClass('hide');
                $('#upload-title-private').removeClass('hide');
            } else if (_tab_name == 'PUBLIC') {
                // remove the force private field for other tabs
                $('[name="force_private"]').remove();
                $('#video-intro-flag').val(0);
                $('.upload-title').addClass('hide');
                $('#upload-title-public').removeClass('hide');
            } else if (_tab_name == 'INTRO') {
                $('[name="force_private"]').remove();
                $('#video-intro-flag').val(1);
                $('.upload-title').addClass('hide');
                $('#upload-title-intro').removeClass('hide');
            }
        }
    };

    this.addInitializer(function() {
        data.init();

        // bind for calling media.add
        self.vent.on('init_js:media:add', events.gallery_add_forms, this);

        // binds for setting up profile/gallery uploads (in a modal currently)
        self.vent.on(self.moduleName+":setup_profile_pic_upload_modal", events.setup_profile_pic_upload_modal, this);
        self.vent.on(self.moduleName+":setup_gallery_upload_modal", events.setup_gallery_upload_modal, this);
        self.vent.on(self.moduleName+":setup_mobile_post_upload_modal", events.setup_mobile_post_upload_modal, this);
        self.vent.on(self.moduleName+":chat_upload", events.chat_upload, this);
    });
});
